import React from 'react'

function About() {
  return (
    <div>
        <h1 className='text-6xl mb-4'>Github Finder</h1>
        <p className='mb-4 text-2xl font-light'>
        A React app to search GitHub profiles and see profile details. This
        project is part of the
        <a href='https://www.udemy.com/course/modern-react-front-to-back/' className='font-bold'>
          {' '}
          React Front To Back
        </a>{' '}
        Udemy course by
        <strong>
          <a href='https://traversymedia.com' className='font-bold'> Brad Traversy</a>
        </strong>
        .
      </p>
    </div>
  )
}

export default About